import React from 'react';

import { DateRangeVariant, SelectedTimeRange } from '@lyearn/ui';
import DatePicker from '@/components/DatePicker';
import { CellProps } from '@/modules/corporate/modules/database/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';
import { getCurrentTimeZoneValue } from '@/utils/timezone';

const DateEditable: React.FC<CellProps> = (props) => {
  const { column, rowData, cellData, toggleIsEditing, onAction } = props;

  const value = {
    startDate: cellData?.value || new Date().toISOString(),
    endDate: cellData?.metadata?.d?.endDate,
    hasEndDate: !!cellData?.metadata?.d?.endDate,
    includeTime: !!cellData?.metadata?.d?.timeFormat,
  };

  const onChange = (val: SelectedTimeRange) => {
    onAction({
      type: TableViewActionTypes.UpdateCellValue,
      payload: {
        fieldId: column.id,
        documentId: rowData._id,
        data: {
          value: val?.startTime?.toISOString() || '',
          metadata: {
            d: {
              startDate: val?.startTime?.toISOString() || '',
              endDate: val?.endTime?.toISOString(),
              timeFormat: value.includeTime ? "H':'mm" : null,
              timeZone: getCurrentTimeZoneValue(),
            },
          },
        },
      },
    });
    toggleIsEditing();
  };

  return (
    <>
      <DatePicker
        open
        pickerProps={{
          variant: DateRangeVariant.DateAndTimeRange,
          selectedRange: { startTime: new Date(value.startDate), endTime: new Date(value.endDate) },
          onChange,
        }}
      />
    </>
  );
};

export default DateEditable;
